import { cn } from "@/shared/utils/cn";

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      data-testid="skeleton"
    />
  );
}

export function TaskListSkeleton() {
  return (
    <div className="space-y-3" data-testid="task-list-skeleton">
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-2">
                <Skeleton className="h-4 w-48" />
                <Skeleton className="h-5 w-20" />
              </div>
              <Skeleton className="h-3 w-full mb-3" />
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-1">
                    <Skeleton className="h-4 w-4 rounded-full" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-3 w-20" />
                </div>
                <Skeleton className="h-3 w-16" />
              </div>
            </div>
            <Skeleton className="h-5 w-12 ml-4" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function MessageListSkeleton() {
  return (
    <div className="space-y-4 p-4" data-testid="message-list-skeleton">
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "flex items-start space-x-2",
            i % 3 === 0 ? "justify-end" : ""
          )}
        >
          {i % 3 !== 0 && <Skeleton className="h-8 w-8 rounded-full" />}
          <div className="max-w-[70%]">
            <Skeleton className="h-16 w-48 rounded-lg" />
            <div className="flex items-center space-x-2 mt-1">
              <Skeleton className="h-3 w-16" />
              <Skeleton className="h-3 w-12" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
